require('./brokerStocksContractView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const OKTag = require('components/commons/OKTag/OKTag');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const NextButtonWrapper = require('components/contactCenter/nextButtonWrapper/nextButtonWrapper');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @components
const BrokerStocksContractStep1 = require('components/broker/brokerStocksContract/brokerStocksContractStep1/brokerStocksContractStep1');
const BrokerStocksContractStep2 = require('components/broker/brokerStocksContract/brokerStocksContractStep2/brokerStocksContractStep2');
const BrokerStocksContractStep3 = require('components/broker/brokerStocksContract/brokerStocksContractStep3/brokerStocksContractStep3');
const BrokerStocksContractStepSuccess = require('components/broker/brokerStocksContract/brokerStocksContractStepSuccess/brokerStocksContractStepSuccess');
const BrokerStocksContractStep3RightCol = require('components/broker/brokerStocksContract/brokerStocksContractStep3RightCol/brokerStocksContractStep3RightCol');
const profileActions = require('actions/profile');
const BrokerStockContractLegalText = require('components/broker/brokerStocksContract/brokerStockContractLegalText/brokerStockContractLegalText');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const BrokerStocksContractActions = require('actions/brokerStocksContractForm');
const BrokerCheckingAccountsActions = require('actions/brokerCheckingAccounts');
const BrokerCheckingAccountsIntervenersActions = require('actions/brokerCheckingAccountsInterveners');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');
const pdfActions =  require('actions/mergePreContractualsPDF');
const blockedAccounts = require('actions/blockedAccounts');

// @constants
const { SECOND_STEP, WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, MYPROFILE_BROKER_URL, BROKER_PG_URL } = require('constants/index');
const { HIRE_STOCKS_CONTRACT } = require('constants/operationCodesAccounts');
const { catalogue, analyticsId } = require('components/broker/brokerStocksContract/analytics/brockerStocksContract.tracking');
const { WEALTH_SEPBLAC_BLOCKED_ACCOUNTS } = require('constants/flagBasedFeatures');
// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @contact-center
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class BrokerStocksContractView extends Component {

    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.onAccountChange = this.onAccountChange.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
        this.handleContinueClick = this.handleContinueClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state = {
            selectedOption: SELECTED_VALUES.EMPTY,
            showWizard: false
        };
    }

    componentDidMount() {
        const { requestCheckingAccounts, getBlockedAccounts, immAccounts, flagBasedFeatures, getBlockedAccountBySepblac, history } = this.props;

        if (flagBasedFeatures.get(WEALTH_SEPBLAC_BLOCKED_ACCOUNTS)) {
            getBlockedAccountBySepblac(history);
        }

        if ( __CONTACT_CENTER__ ) {
            const { location: { state }, reset, resetEmailInfo } = this.props;

            const doReset = !state || !state.keepState;

            if (doReset) {
                reset();
                resetEmailInfo();
            }
        }

        requestCheckingAccounts();

        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_STOCKS_CONTRACT);

        scrollToTop();
    }

    componentWillUnmount() {
        if (!__CONTACT_CENTER__) {
            this.props.reset();
        }
    }

    sortAccounts(accountsList, accountsMap) {
        let accountsToOrder = accountsList.filter(account => accountsMap.get(account));
        const orderedAccounts = accountsToOrder.sort((prevId, nextId) => {
            const amountPrev = accountsMap.getIn([prevId, 'balance', 'amount']);
            const amountNext = accountsMap.getIn([nextId, 'balance', 'amount']);
            let result;

            if (amountPrev > amountNext) {
                result = -1
            } else if (amountPrev === amountNext) {
                result = 0;
            } else {
                result = 1;
            }

            return result;
        });

        return orderedAccounts;
    }

    onAccountChange(accountId) {
        const {
            immBrokerCheckingAccounts,
            immStocksContractForm,
            requestCheckingAccountInterveners,
            reset,
            resetAccount,
            setAccount
        } = this.props;
        const account = immBrokerCheckingAccounts.getIn(['byId', accountId]);
        const visibleStep = immStocksContractForm.get('visibleStep');

        if(account) {
            reset(visibleStep);
            __CONTACT_CENTER__ && resetAccount();
            setAccount(account);
            requestCheckingAccountInterveners(account);
        }
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    handleHelpClick() {
        this.props.history.push('/myprofile/broker/preContractInfo');
    }

    buildRightColumn() {
        const { immProfile, immStocksContractForm } = this.props;
        const account = immStocksContractForm.getIn(['steps', SECOND_STEP, 'account']);
        const visibleStep = immStocksContractForm.get('visibleStep');
        const isCollective = immProfile.get('isCollective');

        let title;
        let header;
        let titleClassName;
        let description;
        let extraContent;

        if (visibleStep === WIZARD_FIRST_STEP || visibleStep === WIZARD_SECOND_STEP) {
            title = formatText('broker-stocksContractSideTitle');

            if (isCollective) {
                extraContent = (
                    <div className="broker-stocks-contract-view__badge">
                        <OKTag content="BUSINESS" type="identification" />
                    </div>
                );
            }
            description = (
                <div>
                    <div className="broker-stocks-contract-right-text">
                        <FormattedText value="broker-stocksContractSideTextParagraph1" />
                    </div>
                    <div>
                        <FormattedText value="broker-stocksContractSideTextParagraph2" />
                    </div>
                </div>
            );

            return (
                <ContentBox title={title} extraContent={extraContent}>
                    {description}
                </ContentBox>
        );

        } else {
            title = formatText('broker-stocksContractTitle');
            titleClassName = "broker-stocks-contract-view__right-column__title-text";

            if (isCollective) {
                extraContent = (
                    <div className="broker-stocks-contract-view__right-column__third-step-badge">
                        <OKTag content="BUSINESS" type="identification" />
                    </div>
                );
                titleClassName = "broker-stocks-contract-view__right-column__title-text broker-stocks-contract-view__right-column__title-text--is-colective";
            }

            description = (<BrokerStocksContractStep3RightCol
                immAccount={account}
                immStocksContractForm={immStocksContractForm}
            />);

            header = (
                <h2 className="broker-stocks-contract-view__right-column">
                    <span className={`${titleClassName}`}>{title}</span>
                    {extraContent}
                </h2>);

            return (
                <div>
                    <ContentBox>
                        {header}
                        {description}
                    </ContentBox>
                </div>
            );

        }
    }


    handleYesNoOptionChange(value) {
        this.setState({
            selectedOption: value
        });
    }

    handleContinueClick() {
        this.setState({
            showWizard: true
        });
    }

    buildNewContractLegalInformation() {
        const {
            sendEmail,
            immProfileFields,
            immPreContractualMail,
            requestProfile,
            resetEmailInfo,
            immContracts
        } = this.props;

        const { selectedOption } = this.state;

        const refreshEmailError = immProfileFields.get('error');
        const email = PersonalDataHelper.getEmail(immProfileFields);
        const isAbleToContinueToWizard = selectedOption === SELECTED_VALUES.YES;
        const contractServicesIndividuals = immContracts && immContracts.get('prestacion_servicios_fisicas');

        return (
            <NextButtonWrapper
                onContinue={this.handleContinueClick}
                canContinue={isAbleToContinueToWizard}
                buttonContainerClassName="broker-stocks-contract-view__continue-button"
            >
                <BrokerStockContractLegalText
                    titleKey="brokerStockContractLegalText-stockContractLegalTitle"
                    refreshEmailAddressError={refreshEmailError}
                    clientEmailAddress={email}
                    sendMail={sendEmail}
                    sendMailParams={{}}
                    immPreContractualMail={immPreContractualMail}
                    immProfileFields={immProfileFields}
                    requestProfile={requestProfile}
                    resetEmailInfo={resetEmailInfo}
                    selectedYesNoOption={this.state.selectedOption}
                    onYesNoOptionChange={this.handleYesNoOptionChange}
                    contractServicesIndividuals={contractServicesIndividuals}
                />
            </NextButtonWrapper>
        )
    }

    buildWizard() {
        const {
            finishReadingPrecontractualDocument,
            flagBasedFeatures,
            getContractInformationWithPricing,
            immBrokerCheckingAccounts,
            immAccounts,
            immContracts,
            immProfile,
            immStocksContractForm,
            requestPDFMerge,
            setTermsAndConditions,
        } = this.props;

        const accountsList = immBrokerCheckingAccounts.get('byOrder');
        const accountsMap = immBrokerCheckingAccounts.get('byId');
        const immSteps = immStocksContractForm.get('steps');
        const visibleStep = immStocksContractForm.get('visibleStep');
        const account = immStocksContractForm.getIn(['steps', SECOND_STEP, 'account']);
        const accountId = account.get('accountId');
        const owner = immBrokerCheckingAccounts.getIn(['byId', accountId, 'interveners', 0, 'name']);
        const accountsIndexes = this.sortAccounts(accountsList, accountsMap);
        const rightColumnBlock = this.buildRightColumn();
        const isCollective = immProfile.get('isCollective');
        const immBlockedAccountsIds = immAccounts.get('blockedAccountsIds');
        const contractServicesIndividuals = immContracts && immContracts.get('prestacion_servicios_fisicas')
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.confirmOperation,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const tealiumData = [
            catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_1_VIEW](),
            catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_2_VIEW](),
            catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_3_VIEW](),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_1_SUCCESS](),
            catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_2_SUCCESS](),
        ];

        const showWizard = !__CONTACT_CENTER__ || this.state.showWizard;
        const showLegalInformation = __CONTACT_CENTER__ && !showWizard;
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        <div className="col-xs-12">
                            {showLegalInformation ? this.buildNewContractLegalInformation() : null}
                            {!showWizard ? null :
                            <Wizard
                                wizardClass={'broker-stocks-contract__wizard'}
                                actions={actions}
                                immSteps={immSteps}
                                stepsAmount={immSteps.size}
                                visibleStep={visibleStep}
                                tealium={tealiumData[visibleStep - 1]}
                                tealiumEvents={{
                                    next: tealiumEvents[visibleStep - 1],
                                }}
                                isTaggingSecondVersion
                            >
                                <WizardStep
                                    position="first"
                                    cancelButton={true}
                                >
                                    <BrokerStocksContractStep1
                                        immStocksContractForm={immStocksContractForm}
                                        isCollective={isCollective}
                                        getContractInformationWithPricing={getContractInformationWithPricing}
                                    />
                                </WizardStep>
                                <WizardStep
                                    position="middle"
                                    cancelButton={true}
                                    nextButton={true}
                                    previousButton={true}
                                >
                                    <BrokerStocksContractStep2
                                        immAccounts={accountsMap}
                                        immStocksContractForm={immStocksContractForm}
                                        accountsIndexes={accountsIndexes}
                                        handleAccountChange={this.onAccountChange}
                                        accountSelected={accountId}
                                        owner={owner}
                                        immBlockedAccountsIds={immBlockedAccountsIds}
                                        isBlockedAccountsLoading={isBlockedAccountsLoading}
                                    />
                                </WizardStep>
                                <WizardStep
                                    position="last"
                                    addLoadingBehaviour={true}
                                    immFinalButton="broker-stocksContractFinish"
                                    cancelButton={true}
                                    finishButton={true}
                                >
                                    <BrokerStocksContractStep3
                                        immAccount={account}
                                        immStocksContractForm={immStocksContractForm}
                                        setTermsAndConditions={setTermsAndConditions}
                                        requestPDFMerge={requestPDFMerge}
                                        contractServicesIndividuals={contractServicesIndividuals}
                                        contrato_prestacion_servicios_personas_fisicas={immContracts.get('prestacion_servicios_fisicas')}
                                        flagBasedFeatures={flagBasedFeatures}
                                        finishReadingPrecontractualDocument={finishReadingPrecontractualDocument}
                                    />
                                </WizardStep>
                            </Wizard>}
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4" id="printable-wizard">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            {rightColumnBlock}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    buildSuccessful() {
        const { immStocksContractForm } = this.props;
        const account = immStocksContractForm.getIn(['steps', SECOND_STEP, 'account']);

        return (
            <div className="col-xs-12 col-md-8">
                <BrokerStocksContractStepSuccess
                    immAccount={account}
                    immStocksContractForm={immStocksContractForm}
                    immProfile={this.props.immProfile}
                />
            </div>
        );
    }

    getBreadcrumbData() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerStocksContract'),
                url: ''
            }
        ];
    }

    render() {
        const { immStocksContractForm, flagBasedFeatures, history, immAccounts } = this.props;
        const ffUsPersonOpenBrokerageAccount = flagBasedFeatures.get('wealth_open_brokerage_account_us_person');
        const mappingBreadcrumb = this.getBreadcrumbData();
        let helpIconAndText;
        let contractBoxContent;

        if (immStocksContractForm.get('submitSuccessful')) {
            contractBoxContent = this.buildSuccessful();
            helpIconAndText = '';
        } else {
            contractBoxContent = this.buildWizard();
            helpIconAndText = (
                <OKButton
                    inverse={true}
                    leftIcon="icon-informacion"
                    modifier="ghost"
                    onClick={() => this.handleHelpClick()}
                >
                    <FormattedText value="stocksContract-helpText" format="firstUppercase" />
                </OKButton>
            );
        }

        const content = (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                className="broker-stocks-contract-view__header"
                                finalTitle={getFinalTitle('broker-stocksContractViewTitle')}>
                                {helpIconAndText}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body broker-stocks-contract-view__body">
                    <div className="container-fluid broker-stocks-contract-view__container">
                        <div className="row grid-view--content-position-negative">
                            {contractBoxContent}
                        </div>
                    </div>
                </div>
            </div>
        )

        if (immAccounts.get('isFetchingBlockedAccountBySepblac')) {
            return <LoadingSection />;
        }

        return (
            <ModalUsPersonBlock
                children={content}
                featureFlag={ffUsPersonOpenBrokerageAccount}
                titleKey={"us_person_popup-open_brokerage_account_title"}
                description={"us_person_popup-open_brokerage_account_message"}
                buttonClick={() => history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerStocksContractView.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    getContractInformationWithPricing: PropTypes.func,
    history: PropTypes.object.isRequired,
    immStocksContractForm: PropTypes.object.isRequired,
    location: PropTypes.object,
    immBrokerCheckingAccounts: PropTypes.object.isRequired,
    setAccount: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    setLegalConfirmationAnswer: PropTypes.func.isRequired,
    confirmOperation: PropTypes.func,
    validateStep: PropTypes.func,
    requestCheckingAccountInterveners: PropTypes.func,
    setTermsAndConditions: PropTypes.func,
    requestCheckingAccounts: PropTypes.func,
    reset: PropTypes.func.isRequired,
    resetAccount: PropTypes.func.isRequired,
    finishReadingPrecontractualDocument: PropTypes.func.isRequired,
    resetEmailInfo: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendEmail: PropTypes.func.isRequired,
    immProfileFields:  PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    immContracts: PropTypes.object,
    getBlockedAccountBySepblac: PropTypes.func.isRequired
}

module.exports.constructor = BrokerStocksContractView;
module.exports.BrokerStocksContractView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immStocksContractForm: state.brokerStocksContractForm,
        immBrokerCheckingAccounts: state.brokerCheckingAccounts,
        immProfileFields: state.profile,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immAccounts: state.accounts,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos'])
    }), {
        getContractInformationWithPricing: BrokerStocksContractActions.getContractInformationWithPricing,
        finishReadingPrecontractualDocument: BrokerStocksContractActions.finishReadingPrecontractualDocument,
        reset: BrokerStocksContractActions.reset,
        resetAccount: BrokerStocksContractActions.resetAccount,
        resetEmailInfo: preContractualMailInfoActions.resetPrecontractualMail,
        setAccount: BrokerStocksContractActions.setAccount,
        setVisibleStep: BrokerStocksContractActions.setVisibleStep,
        setWillLeave: BrokerStocksContractActions.setWillLeave,
        setWillCancel: BrokerStocksContractActions.setWillCancel,
        validateStep: BrokerStocksContractActions.validateStep,
        requestProfile: profileActions.requestProfile,
        sendEmail: BrokerStocksContractActions.sendEmailNotification,
        setLegalConfirmationAnswer: BrokerStocksContractActions.setQuestionAnswer,
        confirmOperation: BrokerStocksContractActions.confirmOperation,
        requestCheckingAccountInterveners: BrokerCheckingAccountsIntervenersActions.requestCheckingAccountInterveners,
        setTermsAndConditions: BrokerStocksContractActions.setTermsAndConditions,
        requestCheckingAccounts: BrokerCheckingAccountsActions.requestCheckingAccounts,
        requestPDFMerge: pdfActions.requestPDFMerge,
        getBlockedAccounts: blockedAccounts.getBlockedAccounts,
        getBlockedAccountBySepblac: blockedAccounts.getBlockedAccountBySepblac
    })(withRouter(BrokerStocksContractView));
